import { modifier } from 'ember-modifier';
import { scheduleOnce } from '@ember/runloop';
import scrollIntoView from 'scroll-into-view-if-needed';

// need to entangle the `selectedIndex` prop so that it triggers auto-tracking
// eslint-disable-next-line no-unused-vars
export default modifier((element, [selectedIndex, selectedItemClassName]) => {
  const selectedItem = element.querySelector(`.${selectedItemClassName}`);

  if (selectedItem) {
    // scroll into view once list updates
    scheduleOnce('afterRender', this, () => {
      scrollIntoView(selectedItem, {
        scrollMode: 'if-needed',
        block: 'nearest',
        inline: 'nearest',
        boundary: element,
      });
    });
  }
}, { eager: false });
